// Dependencies
import React, {Component} from "react";
import {Provider} from "react-redux";
import {Route, Switch} from "react-router-dom";

// Components
import SpecialPrizesPresetConfiguration from "../components/Configuration/SpecialPrizesPresetConfiguration.component";
import SpecialPrizesPresetsList from "../components/List/SpecialPrizesPresetsList.component";

// Utils
import {checkPermission} from "../../../../src/utils/Authorization/authorization";

// Store
import {specialPrizesPresetsStore} from "../store/store";

class SpecialPrizesPresetsPage extends Component {
    render() {
        return (
            <Provider store={specialPrizesPresetsStore}>
                <div id="PresetsPage">
                    <Switch>
                        {checkPermission("add_prog_presets") &&
                            "config:settings:progressives:presets:create" && (
                                <Route
                                    path={"/admin/special-prizes-presets/new"}
                                    component={SpecialPrizesPresetConfiguration}
                                />
                            )}

                        {checkPermission("add_prog_presets") &&
                            "config:settings:progressives:presets:create" && (
                                <Route
                                    path="/admin/special-prizes-presets/edit/:presetId"
                                    component={SpecialPrizesPresetConfiguration}
                                />
                            )}

                        {checkPermission("list_prog_presets") && (
                            <Route
                                path="/admin/special-prizes-presets/detail/:presetId"
                                component={SpecialPrizesPresetConfiguration}
                            />
                        )}

                        {checkPermission("list_prog_presets") && (
                            <Route
                                path={"/admin/special-prizes-presets"}
                                component={SpecialPrizesPresetsList}
                            />
                        )}
                    </Switch>
                </div>
            </Provider>
        )
    }
}

export default SpecialPrizesPresetsPage